import React from 'react';
import SolutionInstallmentExaminationContractCompleteContainer from 'containers/SolutionInstallmentExaminationContractCompleteContainer/SolutionInstallmentExaminationContractCompleteContainer';

export default function SolutionInstallmentExaminationContractCompletePage() {
    return (
        <SolutionInstallmentExaminationContractCompleteContainer />
    )
}
